import axiosInstance from "./axiosInstance";

const base = (hotelId) => `/api/v1/hotels/${hotelId}/analytics`;

const get = async (url, params) => {
    const response = await axiosInstance.get(url, { params });
    return response?.data ?? null;
};

export const fetchSummary = (hotelId, range) =>
    get(`${base(hotelId)}/summary`, { from: range.from, to: range.to });

export const fetchRequests = (hotelId, range) =>
    get(`${base(hotelId)}/requests`, { from: range.from, to: range.to });

export const fetchTrends = (hotelId, range, granularity) =>
    get(`${base(hotelId)}/trends`, { from: range.from, to: range.to, granularity });

export const fetchStaff = (hotelId, range) =>
    get(`${base(hotelId)}/staff`, { from: range.from, to: range.to });

export const fetchUpsell = (hotelId, range) =>
    get(`${base(hotelId)}/upsell`, { from: range.from, to: range.to });

export const fetchGuests = (hotelId, range) =>
    get(`${base(hotelId)}/guests`, { from: range.from, to: range.to });

export const fetchInsights = (hotelId, week) =>
    get(`${base(hotelId)}/insights`, week ? { week } : undefined);

export const fetchOverview = async (hotelId, range, granularity) => {
    const [summary, requests, trends] = await Promise.all([
        fetchSummary(hotelId, range),
        fetchRequests(hotelId, range),
        fetchTrends(hotelId, range, granularity),
    ]);

    return { summary, requests, trends };
};
